
export interface v_WaterRecordModel {
  Count?: any;
  ExcelLicenseSDate: string;
  ExcelLicenseEDate: string;
  ExcelSerialNo: string;
  ExcelQKM3: string;
  WRGuideString?: any;
  isRecord: boolean;
  ApplyMain_sn: number;
  CaseNo: string;
  SerialNo: number;
  Gov_code_sn: number;
  Gov_code_name: string;
  ApplyType_code_sn: number;
  ApplyType_code_name: string;
  ApplyKind_code_sn: number;
  ApplyKind_code_name: string;
  ApplyDate: Date;
  ReceiveDate: Date;
  ReceiveNo: string;
  LicenseNo: string;
  EffectiveSDate: Date;
  EffectiveEDate: Date;
  RelatedNo: string;
  ManageWellNo: string;
  CaseTypeBinary: number;
  isValid: boolean;
  VerifyState_code_sn: number;
  ApplyCase_sn: number;
  ApplyClass_code_sn: number;
  ApplyPerson_sn: number;
  ApplyPersonID: string;
  ApplyPersonName: string;
  ApplyPersonCity_sn: number;
  ApplyPersonCity_name: string;
  ApplyPersonTown_sn: number;
  ApplyPersonTown_name: string;
  ApplyPersonAddress: string;
  ApplyPersonTel: string;
  RightsPerson: string;
  RightsUnit: string;
  ProxyPerson_sn: number;
  ProxyPersonID: string;
  ProxyPersonName: string;
  ProxyPersonCity_sn?: any;
  ProxyPersonCity_name: string;
  ProxyPersonTown_sn?: any;
  ProxyPersonTown_name: string;
  ProxyPersonAddress: string;
  ProxyPersonTel: string;
  WaterKind_code_sn: number;
  WaterKind_code_name: string;
  WaterClass_code_sn: number;
  WaterClass_code_name: string;
  WaterType_code_sn: number;
  WaterType_code_name: string;
  LicenseSDate: Date;
  LicenseEDate: Date;
  InputDate: Date;
  UpdateDate: Date;
  OtherRemark: string;
  WRPlace_sn: number;
  City_sn: number;
  City_name: string;
  Town_sn: number;
  Town_name: string;
  Section_sn: number;
  Section_name: string;
  Subsection_sn?: any;
  Subsection_name: string;
  PlaceLandNo: string;
  PlaceRemark: string;
  PlacePerson: string;
  TM2X97: number;
  TM2Y97: number;
  TM2X67: number;
  TM2Y67: number;
  UseRange: string;
  UseMethod_code_sn?: any;
  UseMethod_code_name: string;
  UseMethodText: string;
  OutPlaceText: string;
  OutTM2X97?: any;
  OutTM2Y97?: any;
  WRGuide_sn?: any;
  WaterGuide_code_sn?: any;
  WaterGuide_code_name: string;
  Stream_code_sn?: any;
  Stream_code_name: string;
  StreamFirst_code_sn?: any;
  StreamFirst_code_name: string;
  StreamSecond_code_sn?: any;
  StreamSecond_code_name: string;
  StreamThird_code_sn?: any;
  StreamThird_code_name: string;
  TributaryText: string;
  OptLocalWater_sn?: any;
  OptLocalWater_name: string;
  OptRDW_sn?: any;
  OptRDW_name: string;
  OptRDWText: string;
  TidalRiverText: string;
  WRKind_sn: number;
  PublicWaterKind_code_sn?: any;
  PublicWaterKind_code_name: string;
  PublicWaterCount?: any;
  PublicWaterNeed?: any;
  EasyWaterSystem_code_sn?: any;
  EasyWaterSystem_code_name: string;
  FarmSelect: string;
  FarmArea?: any;
  FarmCount?: any;
  FarmText: string;
  WaterHeight?: any;
  WaterWatt?: any;
  IndustryArea: number;
  IndustryFloorArea?: any;
  IndustryPerson: number;
  IndustryPay?: any;
  IndustryText: string;
  OtherText: string;
  WRWell_sn: number;
  WellMaterial_code_sn: number;
  WellMaterial_code_name: string;
  WellDiameter: number;
  WellDepth: number;
  WellStaticWater?: any;
  WellPumpWater?: any;
  WellDown?: any;
  WellMaxWater: number;
  GWCompany_name: string;
  PumpCount: number;
  PumpType_code_sn: number;
  PumpType_code_name: string;
  PumpIn: number;
  PumpOut: number;
  PumpHead: number;
  PumpPower: number;
  PumpPosition: boolean;
  PumpPositionMeter: number;
  PumpMaxWater: number;
  WRSpring_sn?: any;
  SpringArea_code_sn?: any;
  SpringArea_code_name: string;
  SpringQuality: string;
  SpringDegree?: any;
  SpringRule: string;
  SpringRemark: string;
  DayAmount1: number;
  DayAmount2: number;
  DayAmount3: number;
  DayAmount4: number;
  DayAmount5: number;
  DayAmount6: number;
  DayAmount7: number;
  DayAmount8: number;
  DayAmount9: number;
  DayAmount10: number;
  DayAmount11: number;
  DayAmount12: number;
  WaterAmountText: string;
  AmountTM2X97?: any;
  AmountTM2Y97?: any;
  AmountRemark: string;
  SecAmount1: number;
  SecAmount2: number;
  SecAmount3: number;
  SecAmount4: number;
  SecAmount5: number;
  SecAmount6: number;
  SecAmount7: number;
  SecAmount8: number;
  SecAmount9: number;
  SecAmount10: number;
  SecAmount11: number;
  SecAmount12: number;
  AmountClass_code_sn: number;
  HrAmount1: number;
  HrAmount2: number;
  HrAmount3: number;
  HrAmount4: number;
  HrAmount5: number;
  HrAmount6: number;
  HrAmount7: number;
  HrAmount8: number;
  HrAmount9: number;
  HrAmount10: number;
  HrAmount11: number;
  HrAmount12: number;
  ProtectDataCheck: string;
  QKM3: number;
  WellCaseNo: string;
}
export class Mv_Sketch {
  IsPost: boolean;
  FielNo: string;
  DateE: string;
  Attachment: string;
  Subject: string;
  AccordingTo: string;
  Bulletin: string;
  BulletinOne: string;
  BulletinTwo: string;
  OrginalSketch: string;
  ChiefName: string;
  Implement: string;
  IssueDateYear: number;
  IssueDateMonth: number;
  IssueDateDate: number;
  IssueWord: string;
  IssueNo: string;
  ApplyPersonName: string;
  RightsPerson: string;
  ApplyData: string;
  ApplyType_code_name: string;
  LicenseDate: string;
  WaterKind_code_name: string;
  WRGuid: string;
  UseRange: string;
  UseMethodText: string;
  WRPlace: string;
  Coordinate: string;
  CoordinateE: string;
  CoordinateN: string;
  OutWRPlace: string;
  d1: number;
  d2: number;
  d3: number;
  d4: number;
  d5: number;
  d6: number;
  d7: number;
  d8: number;
  d9: number;
  d10: number;
  d11: number;
  d12: number;
  m1: number;
  m2: number;
  m3: number;
  m4: number;
  m5: number;
  m6: number;
  m7: number;
  m8: number;
  m9: number;
  m10: number;
  m11: number;
  m12: number;
  h1: number;
  h2: number;
  h3: number;
  h4: number;
  h5: number;
  h6: number;
  h7: number;
  h8: number;
  h9: number;
  h10: number;
  h11: number;
  h12: number;
  WellDepthOrWaterHeight: string;
  OtherRemark: string;
  SurveyOtherRemark: string;
  GovName: string;
  GovAddress: string;
  GovFax: string;
  Recipient: string;
  LevelUrgency: string;
  LicenseNo: string;
  IsElim: boolean;
  BulletinState: number;
  Gov_code_sn: number;
  Page: number;
  Sketch_sn: number;
  Sketch_code_sn: number;
  Sketch_code_name: string;
}
export class Select {
  Name: string;
  Value: number;
}
export class Mv_Code {
  state: boolean;
  Code_sn: number;
  Class_sn: number;
  Code_id: string;
  Code_name: string;
  isValid: boolean;
  Refer_sn: number;
  Note: string;
  Note1: string;
  Note2: string;
  Note3: string;
  Note4: string;
  Sort: number;
  KanghanState: boolean;
}
export class Mv_WaterRecordStatistics {
  WaterRecordStatistics_sn: number;
  Statistics_code_sn: number;
  Statistics_code_name: string;
  Gov_code_sn: number = 0;
  Gov_code_name: string;
  StatisticsYear: Date;
  WaterClass_code_sn: number;
  WaterClass_code_name: string;
  ApplyKind_code_sn: number;
  ApplyKind_code_name: string;
  Stream_code_sn: number;
  Stream_code_name: string;
  Town_sn: number = 0;
  Town_name: string;
  City_sn: number;
  City_name: string;
  PublicCount: number = 0;
  FarmCount: number = 0;
  HydraulicCount: number = 0;
  IndustryCount: number = 0;
  OtherCount: number = 0;
  AllCount: number = 0;
  PublicAmount: number = 0;
  FarmAmount: number = 0;
  HydraulicAmount: number = 0;
  IndustryAmount: number = 0;
  OtherAmount: number = 0;
  AllAmount: number = 0;

  //Extend
  PageType: number;
  Year: number;
  Month: number;
  SelectType: number;
  OldStream_code_sn: string;
  OldGov_code_sn: string;
  ExcelSource: number;
}
export class M_OldGov {
  OrgNo: number;
  Org: string;
  OrgKind: string;
  AliasName: string;
  OfficialCode: string;
  OrgLetter: string;
  Area: number;
  ShowOrder: number;
  NoUseFlag: boolean;
  NoUseReason: string;
}
export class M_OldStream {
  StreamMain: string;
  StreamMainCode: number;
}
export class M_OldTown {
  TownCode: number;
  TownName: string;
}
export class M_Broadcast {
  Broadcast_sn: number;
  Broadcast_code_sn: number;
  Tittle: string;
  Message: string;
  Target_code_sn: number;
  InputUserInfo_sn: number;
  InputDate: Date;
  UpdateUserInfo_sn: number;
  UpdateDate: Date;
  DeleteUserInfo_sn?: any;
  DeleteDate: Date;
  Publisher: string;
}
export class M_FileUpload {
  FileUpload_sn: number;
  Table_sn: number;
  FileType_code_sn: number;
  FileName: string;
  FilePath: string;
  UploadDate: Date;
  UploadUserInfo_sn: number;
  OnlineAppendix_name: string;
}
export class Mv_WaterRecordPersonGroup {
  WaterRecordPersonGroup_sn: number;
  WaterRecordPerson_sn: number;
  PersonName: string;
  ID: string;
  WaterRecordGroup_sn: number;
  GroupName: string;
  GroupUpper_sn: number;
  GroupType: number;
  Email: string;
  Tel: string;
  Phone: string;
  Town_sn: number;
  Addr: string;
  IDate: string;
  DMark: boolean;
  Town_name: string;
  City_name: string;
  City_sn: number;
  CheckCode: string; //驗證碼
}
export class Mv_WaterRecordLicen {
  IsRecorded: boolean;
  RecordType: number = 0;
  ApplyPersonName: string;
  ApplyPersonTel: string;
  RightsPerson: string;
  WaterRecordLicen_sn: number;
  WaterRecordGroup_sn: number = 0;
  ApplyMain_sn: number;
  Gov_code_sn: number = 0;
  Gov_code_name: string;
  ApplyType_code_sn: number = 0;
  ApplyType_code_name: string;
  ApplyKind_code_sn: number = 0;
  ApplyKind_code_name: string;
  LicenseNo: string;
  EffectiveSDate: string;
  EffectiveEDate: string;
  RelatedNo: string;
  VerifyState_code_sn: number;
  ApplyClass_code_sn: number = 0;
  LicenseSDate: string;
  LicenseEDate: string;
  City_sn: number = 0;
  City_name: string;
  Town_sn: number = 0;
  Town_name: string;
  Section_sn: number;
  Section_name: string;
  Subsection_sn: number;
  Subsection_name: string;
  PlaceLandNo: string;
  PlaceRemark: string;
  PlacePerson: string;
  ProtectDataCheck: string;
  WaterKind_code_sn: number = 0;
  WaterKind_code_name: string;
  WaterClass_code_sn: number = 0;
  WaterClass_code_name: string;
  WaterType_code_sn: number = 0;
  WaterType_code_name: string;
  PlaceLandNoA: string;
  PlaceLandNoB: string;
  GroupUpper_sn: number;
  GroupName: string;
  CaseNo: string;
  Option_code_sn: number; //用水標的-使用別
  OptionSub_code_sn: number;//用水標的-次級使用別
  OptionName: string;//使用別
  IsCheck = false;
  IsWaterMeter: boolean; //是否水表
  IsEdit = true; // 水權狀是否能編輯
  WRDevice_code_name: string; // 水權登記量水設備
}
export class M_WaterRecordPerson {
  RecordYear: number;
  RecordMonth: number;
  WaterRecordPerson_sn: number;
  WaterRecordGroup_sn: number;
  GroupName: string;
  PersonName: string;
  ID: string;
  Email: string;
  Tel: string;
  Phone: string;
  Town_sn: number;
  Addr: string;
  IDate: string;
  DMark: boolean;
  GroupType: number;
  CaseCount: number;
  CaseDoneCount: number;
}
export class M_City {
  City_sn: number;
  City_id: string;
  City_name: string;
  Valid: number;
  City_Merge: string;
}
export class M_Town {
  Town_sn: number;
  Town_id: string;
  City_sn: number;
  Town_name: string;
  Post_no: number;
  Station_id: string;
  Town_Merge?: any;
}
export class M_Section {
  Section_sn: number;
  Section_id: string;
  Section_name: string;
  Town_sn: number;
  City_sn: number;
}
export class M_SubSection {
  Subsection_sn: number;
  Subsection_id: string;
  Subsection_name: string;
  Section_sn: number;
}
export class M_WaterRecordWater {
  WaterRecordMeter_sn: number;
  ApplyMain_sn: number;
  RelatedNo: string;
  IsWaterMeter: boolean;
  RecordString: string = null;
  DeviceKind_code_name = "";
  IsValid: boolean;
}
export class Mv_WaterRecordData {
  WaterRecordData_sn: number;
  ApplyMain_sn: number;
  RecordYear: number;
  RecordMonth: number;
  RecordNote: string;
  Record_code_sn: number;
  Record_code_name: string;
  RecordWater: number;
  RecordMeter: number;
  RelatedNo: string;
  DataCheck: boolean;
  LicenseNo: string;
  StartYear: number;
  EndYear: number;
  IsDisableWater: boolean;
}
export class M_WaterRecordDataOfAll {
  Year: number;
  WaterRecordDataOfYear = new Mv_WaterRecordData();
}
export interface Mv_WRAmount {
  WRAmount_sn: number;
  ApplyCase_sn: number;
  AmountType_code_sn: number;
  AmountType_code_name: string;
  AmountClass_code_sn: number;
  AmountClass_code_name: string;
  Amount1: number;
  Amount2: number;
  Amount3: number;
  Amount4: number;
  Amount5: number;
  Amount6: number;
  Amount7: number;
  Amount8: number;
  Amount9: number;
  Amount10: number;
  Amount11: number;
  Amount12: number;
  WaterAmountText: string;
  AmountTM2X97: string;
  AmountTM2Y97: string;
  Remark: string;
}
export class Mv_WaterRecordDataLog {
  WaterRecordDataLog_sn: number;
  WaterRecordData_sn: number;
  OldWaterValue: number;
  NewWaterValue: number;
  OldMeterValue: number;
  NewMeterValue: number;
  OldNote: string;
  NewNote: string;
  InputDate: string;
  WaterRecordPerson_sn: number;
  PersonName: string;
  ApplyMain_sn: number;
  RelatedNo: string;
  RecordYear: number;
  RecordMonth: number;
}
export class Mv_Register {
  Count?: any;
  ExcelLicenseSDate: string;
  ExcelLicenseEDate: string;
  ExcelSerialNo: string;
  ExcelQKM3: string;
  WRGuideString?: any;
  isRecord: boolean;
  ApplyPersonID: string;
  ApplyPersonName: string;
  ApplyPersonAddress: string;
  ApplyPersonTel: string;
  ProxyPersonID: string;
  ProxyPersonName: string;
  ProxyPersonAddress: string;
  ProxyPersonTel: string;
  ApplyMain_sn: number;
  CaseNo: string;
  SerialNo: number;
  Gov_code_sn: number;
  Gov_code_name: string;
  ApplyType_code_sn: number;
  ApplyType_code_name: string;
  ApplyKind_code_sn: number;
  ApplyKind_code_name: string;
  ApplyDate: Date;
  ReceiveDate?: any;
  ReceiveNo: string;
  LicenseNo: string;
  EffectiveSDate: Date;
  EffectiveEDate: Date;
  RelatedNo: string;
  ManageWellNo: string;
  CaseTypeBinary: number;
  isValid: boolean;
  VerifyState_code_sn: number;
  ApplyCase_sn: number;
  ApplyClass_code_sn: number;
  ApplyPerson_sn: number;
  ApplyEnPersonID?: any;
  ApplyEnPersonName?: any;
  ApplyPersonCity_sn: number;
  ApplyPersonCity_name: string;
  ApplyPersonTown_sn: number;
  ApplyPersonTown_name: string;
  ApplyEnPersonAddress?: any;
  ApplyEnPersonTel?: any;
  RightsPerson: string;
  RightsUnit: string;
  ProxyPerson_sn: number;
  ProxyEnPersonID?: any;
  ProxyEnPersonName?: any;
  ProxyPersonCity_sn: number;
  ProxyPersonCity_name: string;
  ProxyPersonTown_sn: number;
  ProxyPersonTown_name: string;
  ProxyEnPersonAddress?: any;
  ProxyEnPersonTel?: any;
  WaterKind_code_sn: number;
  WaterKind_code_name: string;
  WaterClass_code_sn: number;
  WaterClass_code_name: string;
  WaterType_code_sn: number;
  WaterType_code_name: string;
  LicenseSDate: Date;
  LicenseEDate: Date;
  InputDate: Date;
  UpdateDate: Date;
  OtherRemark: string;
  WRPlace_sn: number;
  City_sn: number;
  City_name: string;
  Town_sn: number;
  Town_name: string;
  Section_sn: number;
  Section_name: string;
  Subsection_sn?: any;
  Subsection_name: string;
  PlaceLandNo: string;
  PlaceRemark: string;
  PlacePerson: string;
  TM2X97: number;
  TM2Y97: number;
  TM2X67: number;
  TM2Y67: number;
  UseRange: string;
  UseMethod_code_sn?: any;
  UseMethod_code_name: string;
  UseMethodText: string;
  OutPlaceText: string;
  OutTM2X97?: any;
  OutTM2Y97?: any;
  WRGuide_sn: number;
  WaterGuide_code_sn: number;
  WaterGuide_code_name: string;
  Stream_code_sn: number;
  Stream_code_name: string;
  StreamFirst_code_sn?: any;
  StreamFirst_code_name: string;
  StreamSecond_code_sn?: any;
  StreamSecond_code_name: string;
  StreamThird_code_sn?: any;
  StreamThird_code_name: string;
  TributaryText: string;
  OptLocalWater_sn?: any;
  OptLocalWater_name: string;
  OptRDW_sn?: any;
  OptRDW_name: string;
  OptRDWText: string;
  TidalRiverText: string;
  WRKind_sn: number;
  PublicWaterKind_code_sn?: any;
  PublicWaterKind_code_name: string;
  PublicWaterCount?: any;
  PublicWaterNeed?: any;
  EasyWaterSystem_code_sn?: any;
  EasyWaterSystem_code_name: string;
  FarmSelect: string;
  FarmArea: number;
  FarmCount?: any;
  FarmText: string;
  WaterHeight?: any;
  WaterWatt?: any;
  IndustryArea?: any;
  IndustryFloorArea?: any;
  IndustryPerson?: any;
  IndustryPay?: any;
  IndustryText: string;
  OtherText: string;
  WRWell_sn: number;
  WellMaterial_code_sn?: any;
  WellMaterial_code_name: string;
  WellDiameter?: any;
  WellDepth?: any;
  WellStaticWater?: any;
  WellPumpWater?: any;
  WellDown?: any;
  WellMaxWater?: any;
  GWCompany_name: string;
  PumpCount: number;
  PumpType_code_sn?: any;
  PumpType_code_name: string;
  PumpIn: number;
  PumpOut: number;
  PumpHead?: any;
  PumpPower: number;
  PumpPosition: boolean;
  PumpPositionMeter?: any;
  PumpMaxWater?: any;
  WRSpring_sn?: any;
  SpringArea_code_sn?: any;
  SpringArea_code_name: string;
  SpringQuality: string;
  SpringDegree?: any;
  SpringRule: string;
  SpringRemark: string;
  DayAmount1: number;
  DayAmount2: number;
  DayAmount3: number;
  DayAmount4: number;
  DayAmount5: number;
  DayAmount6: number;
  DayAmount7: number;
  DayAmount8: number;
  DayAmount9: number;
  DayAmount10: number;
  DayAmount11: number;
  DayAmount12: number;
  WaterAmountText: string;
  AmountTM2X97?: any;
  AmountTM2Y97?: any;
  AmountRemark: string;
  SecAmount1: number;
  SecAmount2: number;
  SecAmount3: number;
  SecAmount4: number;
  SecAmount5: number;
  SecAmount6: number;
  SecAmount7: number;
  SecAmount8: number;
  SecAmount9: number;
  SecAmount10: number;
  SecAmount11: number;
  SecAmount12: number;
  AmountClass_code_sn: number;
  HrAmount1: number;
  HrAmount2: number;
  HrAmount3: number;
  HrAmount4: number;
  HrAmount5: number;
  HrAmount6: number;
  HrAmount7: number;
  HrAmount8: number;
  HrAmount9: number;
  HrAmount10: number;
  HrAmount11: number;
  HrAmount12: number;
  ProtectDataCheck: string;
  QKM3: number;
  WellCaseNo: string;
  InputUserInfo_sn?: any;
}
export class Mv_ApplyProcess {
  ApplyProcess_sn: number;
  ApplyMain_sn: number;
  VerifyState_code_sn: number;
  RecordDate: Date;
  UserInfo_sn: number;
}
export class Mv_Seminar {
  Seminar_sn: number;
  Seminar_code_sn: number;
  Seminar_code_name: string;
  IndexShow: boolean;
  OnlineSign: boolean;
  Meal: boolean;
  InputUserInfo_sn: number;
  InputUserName: string;
  InputDate: string;
  UpdateUserInfo_sn: number;
  UpdateUserName: string;
  UpdateDate: string;
  isValid: boolean;
  SeminarContent: string;
}
export class Mv_SeminarDetail {
  IsPeopleLimit: boolean;
  SeminarDetail_sn: number;
  Seminar_sn: number;
  StartDate: string;
  EndDate: string;
  StartTime: string;
  EndTime: string;
  Place: string;
  PeopleLimit: number;
  Seminar_code_sn: number;
  SeminarContent: string;
  IndexShow: boolean;
  OnlineSign: boolean;
  Meal: boolean;
  InputUserInfo_sn: number;
  InputDate: string;
  UpdateUserInfo_sn: number;
  UpdateDate: string;
  isValid: boolean;
  ValidCheck: boolean;
  Num: number;


  StrStartDate: string;  //場次起始時間-String
  StrEndDate: string;    //場次結束時間-String
}
export class Mv_SeminarSign {
  SeminarSign_sn: number;
  SeminarDetail_sn: number;
  Name: string;
  Unit: string;
  Job: string;
  Contact: string;
  LearnMark: boolean;
  ID: string;
  Age: number;
  Edu: string;
  Vegetarian: boolean;
  Birthday: string;
  Email: string;
  InputDate: Date;
}
